import {createBrowserRouter,RouterProvider} from "react-router-dom";

import './App.css';
import Auth from './middleware/Auth';
import Home from './pages/Home';
import AddFolder from "./pages/AddFolder";
import Folder from "./pages/Folder";
import Login from "./pages/Login";
import Register from "./pages/Register";
import AddDoc from "./pages/AddDoc";

const router = createBrowserRouter([
  {
    element: <Auth />,
    children: [
      {
        path: "/",
        element: <Home />,
      },
      {
        path: "/add-folder",
        element: <AddFolder />
      },
      {
        path: "/edit-folder/:id",
        element: <AddFolder />
      },
      {
        path: "/folder/:folderId",
        element: <Folder />
      },
      {
        path: "/add-doc/:folderId",
        element: <AddDoc />
      },
    ]
  },
  {
    path: "/login",
    element: <Login />
  },
  /*
  {
    path: "/register",
    element: <Register />
  }
  */
]);

function App() {
  return (
    <RouterProvider router={router} />
  );
}

export default App;
